import React, {useEffect} from "react";
import {BiSolidLeftArrow, BiSolidRightArrow} from "react-icons/bi";

const TableFooter = ({range, setPage, page, slice}) => {

    useEffect(() => {
        if (slice.length < 1 && page !== 1) {
            setPage(page - 1);
        }
    }, [slice, page, setPage]);


    const onPrev = () => {
        if (page > 1) {
            setPage(page - 1)
        }
    }
    const onNext = () => {
        if (page < range.length) {
            setPage(page + 1)
        }
    }


    return (<>
            <div className="mt-1 flex items-center justify-start">
                <div className={"flex flex-row my-auto"}>
                    <BiSolidLeftArrow
                        onClick={() => onPrev()}
                        className={"text-[#D9D9D9] my-auto cursor-pointer hover:text-[#163578]"}/>
                    <p className={"mx-2 font-bold"}><span
                        className={"text-[#163578]"}>{page}</span><span
                        className={"text-[#979797]"}>/</span><span
                        className={"text-[#979797]"}>{range.length}</span>
                    </p>
                    <BiSolidRightArrow
                        onClick={() => onNext()}
                        className={"text-[#D9D9D9] my-auto cursor-pointer hover:text-[#163578]"}/>
                </div>
            </div>
        </>
    );
};

export default TableFooter;